/**
 * Component: Responsive image realtime re-sizing
 */

var dnDepartments = dnDepartments || {};

dnDepartments.responsiveImages = dnDepartments.responsiveImages || function () {

    /**
     * Init function for the image component.
     */
    this.init = function () {
        loadResponsiveImages();
    };

    /**
     * Load responsive images based on container sizes.
     */
    this.loadResponsiveImages = function () {
        // Call for each element thats responsive
        [].forEach.call(document.querySelectorAll('.js-img-resp'), function(el) {
            // Get src
            var src = el.getAttribute('data-img-src');
            if (src.length > 0) {
                // Check if we should resize
                if (el.getAttribute('data-img-noresize') == null) {
                    if (el.getAttribute('data-img-fixedheight') != null) {
                        var h = el.getAttribute('data-img-fixedheight');
                        // Inject image in proper size
                        el.insertAdjacentHTML('afterbegin', '<img src="' + src + '?height=' + h + '&quality=90&mode=crop" height="' + h + '">');
                    } else {
                        // Get width
                        var w = el.offsetWidth;
                        var wMax = el.getAttribute('data-img-maxwidth');
                        var wMin = el.getAttribute('data-img-minwidth');
                        if (wMax != null) {
                            w = Math.min(w, wMax);
                        }
                        if (wMin != null) {
                            w = Math.max(w, wMin);
                        }
                        // Round width
                        var wRnd = Math.ceil(w / 50) * 50;

                        var fixedAspect = el.getAttribute('data-img-aspect');
                        if (fixedAspect != null) {
                            // Inject image in proper size
                            el.insertAdjacentHTML('afterbegin', '<img src="' + src + '?width=' + wRnd + '&height=' + (wRnd * fixedAspect) + '&quality=90&mode=crop" width="' + w + '">');
                        } else {
                            // Check if we should match height
                            if (el.getAttribute('data-img-matchheight') != null) {
                                // Inject image in proper size
                                el.insertAdjacentHTML('afterbegin', '<img src="' + src + '?width=' + wRnd + '&height=' + wRnd + '&quality=90&mode=crop" width="' + w + '">');
                            } else {
                                // Inject image in proper size
                                el.insertAdjacentHTML('afterbegin', '<img src="' + src + '?width=' + wRnd + '&quality=90" width="' + w + '">');
                            }
                        }
                    }
                } else {
                    // Inject image in original size
                    el.insertAdjacentHTML('afterbegin', '<img src="' + src + '?quality=90">');
                }

                el.className.replace(/\js-img-resp\b/, '');
            } else {
               console.log('Image without src', el);
            }
        });
    }

    // Public functions
    return {
        init: init
    };
}();
